import classNames from 'classnames';
import React from 'react';
import { Link } from 'react-router-dom';

import Icon from 'Views/Components/_HumanWritten/Icon/Icon';

export interface SearchResultOptionProps {
	label: React.ReactNode;
	description: string;
	onClick: () => void;
	iconName: string;
	linkUrl: string;
	useMaterialIcon?: boolean;
	testId?: string;
}

export function SearchResultOption({
	label,
	description,
	onClick,
	iconName,
	linkUrl,
	useMaterialIcon,
	testId,
}: SearchResultOptionProps) {
	const classes = ['search-nav-bar__result__container'];

	return (
		<Link
			to={linkUrl}
			className={classNames(classes)}
			data-test-id={testId}
			onClick={() => {
				onClick();
			}}
		>
			<Icon name={iconName} useMaterialIcons={useMaterialIcon} />
			<div className="search-nav-bar__result__inner">
				<p className="search-nav-bar__result-description">{label}</p>
				<p className="search-nav-bar__result-label">{description}</p>
			</div>
		</Link>
	);
}
